import React, { Component, Fragment } from "react";
import { licenseService } from "../../services/license.service";
import LicenseAddEditForm from "../../components/license-add-edit-form.component";
import { Form, Spinner } from "react-bootstrap";

import { userActivationService } from "../../services/activation-user.service";
import helperService from "../../../../core/commons/services/helper.service";
import DataTable from "react-data-table-component";
import moment from "moment";

export default class SingleLicenseItemPage extends Component {
  constructor() {
    super();
    this.state = {
      isLoaded: false,
      isEdit: false,
      licenseInfo: null,
      dataTableColumns: [],
      activityLog: [],
    };
  }

  getLicenseInfo = async (id) => {
    const licenseInfo = await licenseService.get(id);
    console.log(`Single License Page ->`, licenseInfo);

    if (!licenseInfo.success) {
      alert(licenseInfo.msg);
      return null;
    }
    return licenseInfo.data;
  };

  async componentDidMount() {
    console.log(this.props);

    const { id } = this.props.match.params;

    const licenseInfo = await this.getLicenseInfo(id);

    if (licenseInfo == null) {
      return;
    } else {
      const omitColumns = ["id", "user_id", "license_id", "created_at", "lat", "lon"];
      const growColumn = [];
      const formatColumn = ["created_at", "updated_at"];
      let dataTableColumns = [];

      let activityLog = [];

      if (licenseInfo?.activityLog && licenseInfo.activityLog[0]) {
        dataTableColumns = Object.keys(licenseInfo.activityLog[0]).map((dataKey) => {
          return {
            name:
              dataKey == "updated_at"
                ? "Last update"
                : dataKey == "req_count"
                ? "Count"
                : helperService.handleSentenceCase(dataKey),
            selector: dataKey,
            grow: growColumn.includes(dataKey) ? 5 : 1,
            omit: omitColumns.includes(dataKey) ? true : false,
            format: formatColumn.includes(dataKey)
              ? (row) => {
                  const lastActive = row.updated_at ? row.updated_at : row.created_at;
                  return moment(lastActive).format("MM/DD/YYYY");
                }
              : null,
          };
        });
        activityLog = licenseInfo.activityLog;
      }

      this.setState({ isLoaded: true, licenseInfo, dataTableColumns, activityLog });
    }

    //  this.getLicenseInfo()
  }

  handleDeactivate = async (data, index) => {
    const { licenseInfo } = this.state;
    let item = licenseInfo.activation_list;

    console.log(`Selected Item ->`, item[index]);

    item[index]["active"] ^= 1;
    item[index]["statusChanging"] = true;
    this.setState({ licenseInfo });
    try {
      const updateLicense = await userActivationService.updateUserActivation(item[index]);

      if (!updateLicense.success) {
        item[index]["active"] ^= 1;
      }

      delete item[index]["statusChanging"];

      setTimeout(() => {
        this.setState({ licenseInfo });
      }, 500);
    } catch (error) {}
  };

  renderActivationList = (activationList) => {
    console.log(`Loaded activation List`);
    // console.log(activationList);
    // activationList = undefined
    if (!activationList || activationList.length <= 0) {
      console.log(`Not inside activation list`);
      return (
        <tr colspan="3">
          <td> No records found</td>
        </tr>
      );
    }

    const rows = activationList.map((x, i) => {
      // console.log(`Activation Item -> index -> item =>`, i, x);
      const row = (
        <tr key={i}>
          <td>{x.mac_address}</td>
          <td>{x.created_at}</td>
          <td>{x.last_use_at}</td>
          <td>
            {/* {(x.active == 1) ? "Active" : "Inactive"} */}
            {x["statusChanging"] ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <Form.Check
                key={i}
                checked={x.active == 1 ? true : false}
                onChange={() => this.handleDeactivate(x, i)}
                type="switch"
                id={`custom-switch-${i}`}
                label={x.active == 1 ? "Active" : "Inactive"}
              />
            )}
          </td>
        </tr>
      );

      return row;
    });

    console.log(`This is the row laoded -<`, rows);

    return rows;
  };

  render() {
    const { isEdit, isLoaded, licenseInfo, dataTableColumns, activityLog } = this.state;
    return (
      <Fragment>
        {isLoaded ? (
          <Fragment>
            <div className="my-4 mx-2 pointer">
              <a href="/" style={{ color: "black" }}>
                {"<< "} Back
              </a>
            </div>
            <div className="card">
              <div className="card-body">
                <div className="row mb-4">
                  <div className="col-md-12">
                    {isLoaded ? (
                      <LicenseAddEditForm
                        history={this.props.history}
                        fullView={true}
                        action={"edit"}
                        selectedRow={licenseInfo}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <h1>Activation List</h1>
                  </div>
                  <div className="col-md-12">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Mac Address</th>
                          <th>Activation Time</th>
                          <th>Last Use</th>
                          <th>Status</th>
                        </tr>
                      </thead>

                      <tbody>{this.renderActivationList(licenseInfo.activation_list)}</tbody>
                    </table>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <h1>Activity Log</h1>
                  </div>
                  <div className="col-md-12">
                    <DataTable
                      defaultSortField="req_count"
                      defaultSortAsc={false}
                      columns={dataTableColumns}
                      data={activityLog}
                      noHeader
                    />
                  </div>
                </div>
              </div>
            </div>
          </Fragment>
        ) : (
          ""
        )}
      </Fragment>
    );
  }
}
